module.exports = __webpack_public_path__ + "img/zhiyuan.388b64e2.png";